/**
 * Sidebar navigation manifest.
 *
 * Adding a new admin page? Register it here and (optionally) map a route in
 * `App.tsx`. Items whose routes are not yet implemented are rendered as
 * placeholders via `pages/Placeholder.tsx`.
 */

import {
  BookOpenCheck,
  CalendarClock,
  DollarSign,
  FileText,
  LayoutDashboard,
  MessageSquare,
  Package,
  Phone,
  Repeat,
  ScrollText,
  Settings,
  ShieldAlert,
  Users,
  Wand2,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  implemented: boolean;
  /**
   * Optional role gate. When set, the Sidebar only renders the item for users
   * whose role satisfies this requirement. Story 7.11 uses `admin` for Users
   * and Audit Log. The page itself also shows a 403 banner for direct access,
   * so a non-admin who pastes the URL still gets a clear message.
   */
  requiresRole?: 'admin';
}

export const navItems: NavItem[] = [
  { label: 'Dashboard', to: '/dashboard', icon: LayoutDashboard, implemented: true },
  { label: 'Conversas', to: '/conversations', icon: MessageSquare, implemented: true },
  { label: 'Campanhas', to: '/campaigns', icon: Repeat, implemented: true },
  { label: 'Produtos', to: '/products', icon: Package, implemented: true },
  { label: 'Prompts', to: '/prompts', icon: Wand2, implemented: true },
  { label: 'Templates', to: '/templates', icon: FileText, implemented: true },
  { label: 'Followups', to: '/followups', icon: BookOpenCheck, implemented: true },
  { label: 'Opt-out Keywords', to: '/opt-out-keywords', icon: ShieldAlert, implemented: true },
  { label: 'Números de Teste', to: '/test-numbers', icon: Phone, implemented: true },
  { label: 'Callbacks', to: '/callbacks', icon: CalendarClock, implemented: true },
  { label: 'Custo de IA', to: '/cost-dashboard', icon: DollarSign, implemented: true },
  {
    label: 'Users',
    to: '/users',
    icon: Users,
    implemented: true,
    requiresRole: 'admin',
  },
  {
    label: 'Audit Log',
    to: '/audit-log',
    icon: ScrollText,
    implemented: true,
    requiresRole: 'admin',
  },
  { label: 'Settings', to: '/settings', icon: Settings, implemented: true },
];
